import { translate } from './i18n/i18n';
import { colorPalette } from './theme';

const t = translate(['common']);

export const API_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1';

export const APP_ENV = process.env.REACT_APP_ENV;

export const DEFAULT_ENVIRONMENT = {
  DEMO: 'demo',
  STAGE: 'staging',
  PROD: 'production',
  DEV: 'development',
  OPPORTUNE: 'opportune',
};

export const TOKEN_KEY = '__elrin__auth';
export const DEFAULT_CHOICE_NUDGE_COINS = 100;
export const DEFAULT_TEXT_NUDGE_COINS = 2; // per word
export const DEFAULT_CHOICE_ANSWER_COINS = '02';

export const DEFAULT_PAGE_SIZE = Number(
  process.env.REACT_APP_DEFAULT_PAGE_SIZE || 10,
);

export const DEFAULT_HEATMAP_LIMIT = process.env.DEFAULT_HEATMAP_LIMIT || 50;

export const PASSWORD_REGEX =
  /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{10,}$/;

export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export const DEFAULT_LOGO = process.env.REACT_APP_DEFAULT_LOGO || null;

export const DEFAULT_COMPANY_ID =
  process.env.REACT_APP_DEFAULT_COMPANY_ID || null;

export const DEFAULT_LOGO_HEIGHT =
  process.env.REACT_APP_DEFAULT_LOGO_HEIGHT || 35;

export const MAX_HEATMAP_SIZE = 25;

export const BACKY_ICON = process.env.REACT_APP_BACKY_ICON || null;

export const CHECK_DOMAIN = Boolean(process.env.REACT_APP_CHECK_DOMAIN || 0);

export const DEFAULT_MAXIMUM_SLIDER_VALUE = 10;
export const DEFAULT_MINIMUM_SLIDER_VALUE = 0;

export const DEFAULT_MAXIMUM_SLIDER_RATING_VALUE = 5;
export const DEFAULT_MINIMUM_SLIDER_RATING_VALUE = 1;

export const DEFAULT_MAXIMUM_SLIDER_POS_NEG_RATING_VALUE = 4;
export const DEFAULT_MINIMUM_SLIDER_POS_NEG_RATING_VALUE = 1;

export const DEFAULT_FILE_PREFIX =
  process.env.REACT_APP_DEFAULT_S3_FILES_PREFIX || 'http://assets.elrin.ai/';
export const DEFAULT_S3_FILE_BUCKET_URL =
  process.env.REACT_APP_DEFAULT_S3_FILE_BUCKET_URL;

export const MIBL_SLUG = process.env.REACT_APP_MIBL_SLUG || 'mibl';

export const MAXIMUM_VIDEO_SIZE = 200; // in MB

export const LOGGED_OUT_ROUTES = [
  'login',
  'forgot-password',
  'reset-password',
  'set-password',
  'link-expired',
  'sso',
];

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const AttributeKeys = [
  'happiness',
  'teamwork',
  'recognition',
  'motivation',
  'growth',
];

export const DEFAULT_JOB_ROLE = [
  { value: '1', label: t('role.1') },
  { value: '2', label: t('role.2') },
  { value: '3', label: t('role.3') },
  { value: '4', label: t('role.4') },
];

export const SENTIMENT_ENUM = {
  NEGATIVE: 'NEG',
  POSITIVE: 'POS',
  NEUTRAL: 'NEU',
};

export const SENTIMENT_LISTS = [
  { value: SENTIMENT_ENUM.NEGATIVE, label: t('sentiment.neg') },
  { value: SENTIMENT_ENUM.NEUTRAL, label: t('sentiment.neu') },
  { value: SENTIMENT_ENUM.POSITIVE, label: t('sentiment.pos') },
];

export const SENTIMENT_INDEX = {
  [SENTIMENT_ENUM.NEGATIVE]: 0,
  [SENTIMENT_ENUM.NEUTRAL]: 1,
  [SENTIMENT_ENUM.POSITIVE]: 2,
};

export const DEFAULT_COLOR_LIST = [
  colorPalette.success[500],
  colorPalette.warning[500],
  colorPalette.danger[500],
];

export const DEFAULT_COLOR = {
  SUCCESS: colorPalette.success[500],
  WARNING: colorPalette.warning[500],
  DANGER: colorPalette.danger[500],
};

export const WORD_CLOUD_COLORS = {
  [SENTIMENT_ENUM.NEGATIVE]: [
    colorPalette.danger[400],
    colorPalette.danger[500],
    colorPalette.danger[600],
    colorPalette.danger[700],
    colorPalette.danger[800],
  ],
  [SENTIMENT_ENUM.POSITIVE]: [
    colorPalette.success[400],
    colorPalette.success[500],
    colorPalette.success[600],
    colorPalette.success[700],
    colorPalette.success[800],
  ],
};

export const TAG_TYPES = [
  { label: t('team'), value: 1 },
  { label: t('department'), value: 2 },
  { label: t('location'), value: 3 },
];

export const ONBOARDING_CARD_COLORS = [
  { color: '#2F6FED', bgColor: '#DCE7FE' },
  { color: '#9E70FA', bgColor: '#EFE7FE' },
  { color: '#0EA472', bgColor: '#D1FAEC' },
  { color: '#DB7712', bgColor: '#FFF1D6' },
];

export const TAG_BADGE_COLOR = {
  T: '#2F6FED',
  D: '#b23e5f',
  G: '#FBBB3C',
};

export const DurationFilter = [
  { value: 0, label: t('durationList.currentEngagement') },
  { value: 1, label: t('durationList.thisMonth') },
  { value: 2, label: t('durationList.lastMonth') },
  { value: 3, label: t('durationList.sixMonth') },
  { value: 4, label: t('durationList.thisYear') },
  { value: 5, label: t('durationList.lastYear') },
];

export const DurationFilterWithAll = [
  { value: null, label: t('durationList.all') },
  ...DurationFilter,
];

export const DurationFilterWithWeek = [
  { value: 0, label: t('durationList.thisWeek') },
  ...DurationFilter,
];

export const SuggestionBoxSentByEnum = {
  ADMIN: 1,
  USER: 2,
};

export const PeriodDuration = {
  W: 0,
  T: 6,
  F: 7,
};

export const PermissionModules = [
  'view_tag',
  'view_target',
  'view_useraccount',
  'view_answer',
  'view_companyevent',
  'view_feedbackconversation',
  'view_question',
];

export const Timezones = [
  { value: 'Asia/Kolkata', label: 'Indian Standard Time' },
  { value: 'Asia/Dubai', label: 'Dubai Time' },
  { value: 'Asia/Tel_Aviv', label: 'Israel Time' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong Time' },
  { value: 'Asia/Jakarta', label: 'Jakarta Time' },
  { value: 'Asia/Singapore', label: 'Singapore Time' },
  { value: 'GMT', label: 'London Time' },
  { value: 'Europe/Stockholm', label: 'Stockholm Time' },
  { value: 'Europe/Oslo', label: 'Norway Time' },
  { value: 'Europe/Paris', label: 'Paris Time' },
  {
    value: 'US/Pacific',
    label: 'Pacific Standard Time / Pacific Daylight Time',
  },
  {
    value: 'US/Central',
    label: 'Central Standard Time / Central Daylight Time',
  },
  {
    value: 'US/Eastern',
    label: 'Eastern Standard Time / Eastern Daylight Time',
  },
];

export const DaysList = [
  { value: 'MON', label: 'Monday' },
  { value: 'TUE', label: 'Tuesday' },
  { value: 'WED', label: 'Wednesday' },
  { value: 'THU', label: 'Thursday' },
  { value: 'FRI', label: 'Friday' },
  { value: 'SAT', label: 'Saturday' },
  { value: 'SUN', label: 'Sunday' },
];

export const ROLE_LISTS = [
  { value: 1, label: t('role.1') },
  { value: 2, label: t('role.2') },
  { value: 3, label: t('role.3') },
  { value: 4, label: t('role.4') },
];

export const HRMS_TYPE = {
  OPPORTUNE: '1',
};

export const OPPORTUNE_CLIENT = ['bgss', 'opportune'];

export const QuestionChoiceFilter = [
  { value: 1, label: t('questionChoice.1') },
  { value: 2, label: t('questionChoice.2') },
  { value: 3, label: t('questionChoice.3') },
  { value: 4, label: t('questionChoice.4') },
  { value: 5, label: t('questionChoice.5') },
  { value: 6, label: t('questionChoice.6') },
  { value: 7, label: t('questionChoice.7') },
  { value: 8, label: t('questionChoice.8') },
  { value: 9, label: t('questionChoice.9') },
];

export const QuestionChoiceFilterWithAll = [
  { value: null, label: t('durationList.all') },
  ...QuestionChoiceFilter,
];

export const DEFAULT_QUESTION_TYPES = {
  MULTIPLE_CHOICE: 0,
  CHOICE: 1,
  INPUT: 2,
  RATING: 3,
  SLIDER: 4,
  EMOJI: 5,
  SLIDER_RATING: 6,
  SLIDER_AGREE_DISAGREE_RATING: 7,
  BEHAVIOUR: 8,
  SLIDER_POS_NEG: 9,
};

export const QuestionTypeList = [
  { label: t(`questionChoice.0`), value: 0 },
  { label: t(`questionChoice.1`), value: 1 },
  { label: t('questionChoice.2'), value: 2 },
  { label: t('questionChoice.3'), value: 3 },
  { label: t('questionChoice.4'), value: 4 },
  { label: t('questionChoice.5'), value: 5 },
  { label: t('questionChoice.6'), value: 6 },
  { label: t('questionChoice.7'), value: 7 },
  { label: t('questionChoice.8'), value: 8 },
  { label: t('questionChoice.9'), value: 9 },
];

export const SchemaSetSchedulePeriodList = [
  { value: 'O', label: t('schemaSetPeriod.once') },
  { value: 'D', label: t('schemaSetPeriod.daily') },
  { value: 'W', label: t('schemaSetPeriod.weekly') },
  { value: 'T', label: t('schemaSetPeriod.tenDays') },
  { value: 'F', label: t('schemaSetPeriod.fortnightly') },
  { value: 'M', label: t('schemaSetPeriod.Monthly') },
];

export const SurveySchemaPeriodDays = {
  D: 1,
  W: 7,
  T: 10,
  F: 15,
  M: 30,
  O: 0,
};

export const SurveyTypeEnum = {
  NORMAL: 1,
  ONBOARDING: 2,
  EXIT: 3,
  BEHAVIOUR: 4,
  TOUCHPOINT: 5,
  EVENT: 6,
};

export const SurveyTypeList = Object.keys(SurveyTypeEnum).map((key) => ({
  label: t(`surveyType.${key}`),
  value: SurveyTypeEnum[key],
}));

export const TouchPointTypeEnum = {
  WELCOME: 6,
  SURVEY: 1,
  VIDEO: 2,
  PDF: 3,
  TEXT: 4,
  CERTIFICATE: 5,
};

export const SurveySchemaSaveTypeEnum = {
  MANDATORY: 1,
  PARTIAL: 2,
  NOT_MANDATORY: 3,
};

export const SurveySchemaSaveTypeList = [
  {
    value: SurveySchemaSaveTypeEnum.MANDATORY,
    label: t('surveySchemaSaveType.1'),
  },
  {
    value: SurveySchemaSaveTypeEnum.PARTIAL,
    label: t('surveySchemaSaveType.2'),
  },
  {
    value: SurveySchemaSaveTypeEnum.NOT_MANDATORY,
    label: t('surveySchemaSaveType.3'),
  },
];

export const JourneyTagIncludeTypeEnum = {
  INCLUDE: 1,
  EXCLUDE: 2,
};

export const JourneyTagConditionEnum = {
  OR: 1,
  AND: 2,
};

export const JourneyTagIncludeType = [
  {
    value: JourneyTagIncludeTypeEnum.INCLUDE,
    label: t('journeyTagTypeIncludeEnum.1'),
  },
  {
    value: JourneyTagIncludeTypeEnum.EXCLUDE,
    label: t('journeyTagTypeIncludeEnum.2'),
  },
];

export const EventTypeList = [
  { value: 1, label: t('eventType.1') },
  { value: 2, label: t('eventType.2') },
  // { value: 3, label: t('eventType.3') },
];

export const ActionItemBoardTypeEnum = {
  TODO: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
};

export const ActionItemBoardTypeList = [
  {
    value: ActionItemBoardTypeEnum.TODO,
    label: t('actionItemBoardType.1'),
    color: '#5381C1',
  },
  {
    value: ActionItemBoardTypeEnum.IN_PROGRESS,
    label: t('actionItemBoardType.2'),
    color: '#FF8C00',
  },
  {
    value: ActionItemBoardTypeEnum.COMPLETED,
    label: t('actionItemBoardType.3'),
    color: '#36D39F',
  },
];
